import { Route, Routes } from "react-router";
import Apps from "./Apps";

function AppsRoutes() {
  return (
    <Routes>
      <Route path="" element={<Apps />} />
      <Route path=":user" element={<Apps />} />
    </Routes>
  );
}

export default AppsRoutes;
